import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export type GetLocationForContentRequestParams = {
  readonly contentType: string;
  readonly contentLuid: string;
}

function getLocationForContentRequestConfig(
  params: GetLocationForContentRequestParams
): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.13',
    httpMethod: 'GET',
    endpoint: `locations/${params.contentType}/${params.contentLuid}`,
    serverWideRequest: false
  };
}

export type ContentLocation = {
  readonly type: string;
  readonly luid: string;
  readonly name: string;
}

export type GetLocationForContentResponse = {
  readonly contentLocation: ContentLocation;
}

export function callViaApiService(
  params: GetLocationForContentRequestParams) {
  return makeJsonRestApiRequest<void, GetLocationForContentResponse>({
    config: getLocationForContentRequestConfig(params),
    request: null,
  });
}